/**
 * State of the best offers
 *
 * @export
 * @class State
 */
export class State {
	best_offers: any;
	flights: any;
	city: any;
	journeys: any;
}

export const initialState: State = {
	best_offers: [],
	flights: [],
	city: '',
	journeys: []
};
